import { put, call, takeLatest } from 'redux-saga/effects'

import { JOB_CODE_PARAM } from 'Constants'

import { getTags as getJobCodesApi, createTag as createJobCodeApi } from 'Service/Api'

import * as JobCodeTypes from 'Redux/Types/JobCodeTypes'
import * as JobCodeActions from 'Redux/Actions/JobCodeActions'

function* getJobCodes() {
  try {
    const { data } = yield call(getJobCodesApi, JOB_CODE_PARAM)
    yield put(JobCodeActions.getJobCodesSucceeded(data))
  } catch (errors) {
    yield put(JobCodeActions.getJobCodesFailed(errors))
  }
}

function* createJobCode({ payload }) {
  const params = {
    value: payload,
    type: { name: JOB_CODE_PARAM },
  }
  try {
    const { data } = yield call(createJobCodeApi, params)
    yield put(JobCodeActions.createJobCodeSucceeded(data))
  } catch (errors) {
    yield put(JobCodeActions.createJobCodeFailed(errors))
  }
}

export default function* JobCodeSaga() {
  yield takeLatest(JobCodeTypes.GET_JOB_CODES, getJobCodes)
  yield takeLatest(JobCodeTypes.CREATE_JOB_CODE, createJobCode)
}
